import React, { useContext, useEffect, useMemo, useState } from "react";
import { Title } from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import { Operation, PageFor } from "../../../../../../utils/Enum.types";
import { Button } from "../../../../../../stories/Button/Button";
import { Label } from "../../../../../../stories/Label/Label";
import {
  EMPTY_STRING,
  emptyFunc,
  emptyMessage,
  ROWS_PER_PAGE,
} from "../../../../../../utils/constants";
import { Keys } from "../../../../../../utils/Enum.keys";
import { CustomModal } from "../../../../../../utils/UtilFunctions";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import useAssetTableJson from "../../../../../../json/useAssetTableJson";
import { msgType, TableHeaderJsonProps } from "../../../../../../utils/types";
import ItemsAutocomplete from "../../../../../../customComponents/ItemsAutocomplete";
import Enter from "../../../../../../images/Enter.svg";
import Delete from "../../../../../../images/Delete.svg";
import Edit from "../../../../../../images/EditProfile.svg";

import Input from "../../../../../../stories/Input/Input";
import { payloadTypes } from "../../../../../../context/reducer";
import OpenIcon from "../../../../../../images/OpenIcon.svg";
import { ViewModalStyles } from "../../../../../../styles/CustomModalStyles";
import AssetDetailsTable, {
  ItemDetailsTableFor,
} from "../../../reports/assetwise/Table";
import { AssignAssetProps } from "./GroupingAsset";
import { AppContext } from "../../../../../../context/context";
import GroupAutocomplete from "../GroupAutocomplete";
import {
  itmDetailsType,
  itmType,
} from "../../../purchase/material/statesProvider/materialContext";
import InputNumber from "../../../../../common/Input/InputNumber";
import useLabels from "../../../../../../customHooks/useLabels";
import MessageModal from "../../../../../../customComponents/MessageModal";
import { useLazyQuery, useMutation } from "@apollo/client";
import { AddOrUpdateOrDeleteItemGroupAssoic } from "../queries/mutation";
import {
  AddOrUpdateOrDeleteItemGroupAssoicResult,
  AddOrUpdateOrDeleteItemGroupAssoicVars,
  AtsItemGroupOrderField,
  GetItemGroupAssoicResult,
  GetItemGroupAssoicVar,
} from "../queries/types";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import { GetItemGroupAssoic, GetItemGroups } from "../queries/queries";
import { OrderDirection } from "../../../../../../utils/commonQueryTypes";
export const enum AssignAssetPageFor {
  GROUPING_ASSET = "GROUPING_ASSET",
  ASSIGN_ASSET = "ASSIGN_ASSET",
}
interface Props {
  setModal: React.Dispatch<React.SetStateAction<AssignAssetProps>>;
  operation: Operation;
}
interface formType {
  item: itmType;
  itemsDetail?: itmDetailsType;
  itmQty: number;
}

interface formTypes extends formType {
  isAdded: boolean;
  isUpdated: boolean;
  isDeleted: boolean;
  fromDb: boolean;
}

const Add = ({ setModal, operation }: Props) => {
  const { Masters_Table } = useAssetTableJson();

  const { state, dispatch } = useContext(AppContext);

  const { itemLabel } = useLabels();

  const { customer_id } = useUrlParams();

  const { user_details } = useLoggedInUserDetails();

  const [groupDesc, setGroupDesc] = useState("");

  const [edit, setEdit] = useState(false);

  const [GetAssocs, { data }] = useLazyQuery<
    GetItemGroupAssoicResult,
    GetItemGroupAssoicVar
  >(GetItemGroupAssoic);

  const [AssignAssets] = useMutation<
    AddOrUpdateOrDeleteItemGroupAssoicResult,
    AddOrUpdateOrDeleteItemGroupAssoicVars
  >(AddOrUpdateOrDeleteItemGroupAssoic, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const [formData, setFormData] = useState<formType | null>(null);

  const [message, setMessage] = useState<msgType>({
    message: "",
    flag: false,
    operation: Operation.NONE,
  });

  const [assetModal, setAssetModal] = useState(false);

  const [selectedItems, setSelectedItems] = useState<formTypes[]>([]);

  const handleDelete = (id: number) => {
    const foundEle = selectedItems.find((itm) => itm.item.value === id);
    if (foundEle) {
      if (foundEle.fromDb) {
        const updatedData = selectedItems.map((itm) => {
          const { item } = itm;
          if (item.value === id) {
            return {
              ...formData,
              ...itm,
              isDeleted: itm.fromDb,
            };
          } else {
            return itm;
          }
        });
        setSelectedItems(updatedData);
      } else
        setSelectedItems(
          selectedItems.filter(({ item }) => item && item.value !== id)
        );
    }
  };

  const handleEdit = (id: number) => {
    const foundElement = selectedItems.find(({ item }) => item.value === id);

    if (foundElement) {
      setFormData({
        item: foundElement.item,
        itmQty: foundElement.itmQty,
      });
      setEdit(true);
      const firstAutoCompleteRef = document.getElementsByName("itmQty")[0];

      if (firstAutoCompleteRef) {
        (firstAutoCompleteRef as HTMLInputElement).select();
      }
    }
  };

  const handleSubmit = () => {
    const duplicateItem = selectedItems.find(({ item }) =>
      item && formData ? item.value === formData.item.value : false
    );
    if (duplicateItem && edit === false) {
      setMessage({
        flag: true,
        message: `${itemLabel} is already available`,
        operation: Operation.NONE,
      });
    } else {
      if (edit) {
        if (formData) {
          const updatedData = selectedItems.map((itm) => {
            const { item } = itm;
            if (item.value === formData.item.value) {
              return {
                ...formData,
                isAdded: itm.isAdded,
                isDeleted: itm.isDeleted,
                isUpdated: itm.fromDb,
                fromDb: itm.fromDb,
              };
            } else {
              return itm;
            }
          });

          setSelectedItems(updatedData);
        }
      } else {
        if (formData)
          setSelectedItems([
            {
              ...formData,
              isAdded: true,
              isDeleted: false,
              isUpdated: false,
              fromDb: false,
            },
            ...selectedItems,
          ]);
      }
      setFormData(null);
      const firstAutoCompleteRef = document.getElementsByClassName(
        "MuiAutocomplete-input"
      )[2];

      if (firstAutoCompleteRef) {
        (firstAutoCompleteRef as HTMLInputElement).focus();
      }
    }
  };

  const selectedItemIds = useMemo(() => {
    return selectedItems.map(({ item }) => (item ? item.value : 0));
  }, [selectedItems]);

  const handleClearBtn = () => {
    dispatch({
      type: payloadTypes.SET_GROUP_ID,
      payload: {
        groupId: 0,
      },
    });
    setFormData(null);
    setSelectedItems([]);
  };

  useEffect(() => {
    if (customer_id && operation === Operation.UPDATE) {
      GetAssocs({
        variables: {
          customerID: customer_id,
          itemGrpID: state.groupId,
        },
      }).then(({ data }) => {
        if (data && data.GetItemGroupAssoic) {
          setSelectedItems(
            data.GetItemGroupAssoic.map((itm) => ({
              item: {
                code: itm.itemDetails.code,
                label: itm.itemDetails.desc,
                value: itm.itemDetails.id,
              },
              itmQty: itm.qtyNeeded,
              isAdded: false,
              fromDb: true,
              isDeleted: false,
              isUpdated: false,
            }))
          );
          setGroupDesc(
            data.GetItemGroupAssoic.length
              ? data.GetItemGroupAssoic[0].itemGrpDetails.groupName
              : ""
          );
        }
      });
    }
  }, [operation, GetAssocs, data, customer_id, state.groupId]);

  const handleSave = () => {
    const AddFilterItems = selectedItems.filter(
      (res) => res.isAdded && !res.fromDb
    );
    const UpdateFilterItems = selectedItems.filter(
      (res) => res.isUpdated && res.fromDb
    );
    const DeleteFilterItems = selectedItems.filter(
      (res) => res.isDeleted && res.fromDb
    );
    AssignAssets({
      variables: {
        customerID: customer_id!,
        itemGrpID: state.groupId,
        items: {
          AddItems: AddFilterItems.map(({ item, itmQty }) => ({
            itemID: item.value,
            qtyNeeded: itmQty,
          })),
          UpdateItems: UpdateFilterItems.map(({ item, itmQty }) => ({
            itemID: item.value,
            qtyNeeded: itmQty,
          })),
          DeleteItems: data
            ? data.GetItemGroupAssoic.filter((chek) =>
                DeleteFilterItems.map(({ item }) => item.value).includes(
                  chek.itemID
                )
              ).map((itm) => ({
                itemGrpAssoicID: itm.id,
              }))
            : [],
        },
        user_details,
      },
      refetchQueries: [
        {
          query: GetItemGroups,
          variables: {
            after: null,
            customerID: customer_id,
            first: ROWS_PER_PAGE,
            orderBy: {
              direction: OrderDirection.ASC,
              field: AtsItemGroupOrderField.GROUP_NAME,
            },
            name: EMPTY_STRING,
          },
        },
        {
          query: GetItemGroupAssoic,
          variables: {
            customerID: customer_id,
            itemGrpID: state.groupId,
          },
        },
      ],
    }).then(({ data }) => {
      if (data && data.AddOrUpdateOrDeleteItemGroupAssoic) {
        setMessage({
          flag: true,
          message: "Assigned items successfully",
          operation: Operation.CREATE,
        });
      }
    });
  };

  const handleMessageModalClose = () => {
    if (message.flag && message.operation !== Operation.NONE) {
      handleClearBtn();
      setModal({
        flag: false,
        operation: Operation.NONE,
      });
    }
    setMessage(emptyMessage);
  };

  return (
    <div className="grouping-asset__add">
      <div className="grouping-asset__add--title">
        <Title>Add Grouping Asset</Title>
        <img
          src={Close}
          alt=""
          onClick={() =>
            setModal({
              flag: false,
              operation: Operation.NONE,
            })
          }
        />
      </div>
      <div className="grouping-asset__add--autocomplete col-6">
        <div className="label-grid">
          <Label>Grouping Description</Label>
          {operation === Operation.CREATE ? (
            <GroupAutocomplete
              onChange={(newValue) => {
                if (newValue) {
                  dispatch({
                    type: payloadTypes.SET_GROUP_ID,
                    payload: {
                      groupId: newValue.node.id,
                    },
                  });
                } else {
                  dispatch({
                    type: payloadTypes.SET_GROUP_ID,
                    payload: {
                      groupId: 0,
                    },
                  });
                  handleClearBtn();
                }
              }}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  const firstAutoCompleteRef = document.getElementsByClassName(
                    "MuiAutocomplete-input"
                  )[2];

                  if (firstAutoCompleteRef) {
                    (firstAutoCompleteRef as HTMLInputElement).focus();
                  }
                }
              }}
              value={state.groupId}
              label={EMPTY_STRING}
              autoFocus
            />
          ) : (
            <Input disabled value={groupDesc} />
          )}
        </div>
      </div>
      {state.groupId ? (
        <div className="grouping-asset__add--tableblock">
          <TableContainer className="grouping-asset__add--table">
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {Masters_Table.Masters.Grouping.AddAsset.map(
                    (th: TableHeaderJsonProps) => {
                      return <TableCell>{th.labelName}</TableCell>;
                    }
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow className="grouping-asset__add--table--row">
                  <TableCell
                    id="td-center"
                    className="grouping-asset__add--table--slno"
                  ></TableCell>
                  <TableCell className="grouping-asset__add--table--desc edit-cell">
                    {edit ? (
                      formData ? (
                        formData.item.label
                      ) : (
                        ""
                      )
                    ) : (
                      <ItemsAutocomplete
                        onChange={(newValue) => {
                          if (newValue) {
                            setFormData({
                              ...formData,
                              item: newValue,
                              itmQty: 1,
                            });
                          } else {
                            setFormData(null);
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === Keys.ENTER) {
                            const inputNumber =
                              document.getElementsByName("itmQty")[0];
                            if (inputNumber) {
                              (inputNumber as HTMLInputElement).select();
                            }
                          }
                        }}
                        isComponent={true}
                        value={formData ? formData.item.value : 0}
                        placeholder=""
                        filterIds={edit ? [] : selectedItemIds}
                      />
                    )}
                  </TableCell>
                  <TableCell className="grouping-asset__add--table--code">
                    <>{formData ? formData.item.code : ""}</>
                  </TableCell>
                  <TableCell>
                    <InputNumber
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        if (formData)
                          setFormData({
                            ...formData,
                            itmQty: Number(e.target.value),
                          });
                      }}
                      value={formData ? formData.itmQty : 0}
                      name="itmQty"
                      onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                        if (e.key === Keys.ENTER) {
                          handleSubmit();
                        }
                      }}
                    />
                  </TableCell>
                  <TableCell
                    id="td-center"
                    className="grouping-asset__add--table--actions"
                  >
                    <img src={Enter} alt="" onClick={handleSubmit} />
                  </TableCell>
                </TableRow>
                {selectedItems
                  .filter((res) => !res.isDeleted)
                  .map((res, index) => {
                    return (
                      <TableRow>
                        <TableCell id="td-center">{index + 1}</TableCell>
                        <TableCell>{res.item ? res.item.label : ""}</TableCell>
                        <TableCell>{res.item ? res.item.code : ""}</TableCell>
                        <TableCell>{res.itmQty}</TableCell>
                        <TableCell id="td-center">
                          <img
                            src={Edit}
                            alt=""
                            onClick={() => {
                              handleEdit(res.item ? res.item.value : -1);
                            }}
                          />
                          <img
                            src={Delete}
                            alt=""
                            onClick={() => {
                              handleDelete(res.item ? res.item.value : -1);
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      ) : (
        <b className="nodata">Please select Item Group</b>
      )}
      {state.groupId ? (
        <>
          <Button mode="save" onClick={handleSave} />
          <Button mode="clear" onClick={handleClearBtn} />
          <Button
            mode="cancel"
            onClick={() =>
              setModal({
                flag: false,
                operation: Operation.NONE,
              })
            }
          />
        </>
      ) : null}



      <MessageModal
        handleClose={handleMessageModalClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
    </div>
  );
};

export default Add;
